import React, { FunctionComponent, useRef } from "react";
import {
    CircleOuterWrap,
    CircleInnerWrap,
    CentralPercent,
    CircleLeft,
    CircleRight,
    PercentLineTotal,
    PercentLine,
    PercentCounterCircle,
    PercentText,
    LineIndicator,
    LocationName,
} from "../ChartStyles/VennChart";
import { ChartDots, ChartDotsWrap, ChartDot, shortenStr } from "../../Common/";
import {
    colorTwoDark,
    colorTwoBright,
} from "../../../globalStyles/colors/scoutColors";
import { IVennChart } from "../../../Models/Models";

export const VennChart: FunctionComponent<IVennChart> = (props: IVennChart) => {
    const {
        percent1,
        percent2,
        centralPercent,
        centralIcon,
        location1Name,
        location2Name,
        isActive,
    } = props;
    const mobileDiams = {
        initial: 400,
        expanded: 450,
    };
    const desktopDiams = {
        initial: 450,
        expanded: 510,
    };
    const maxStrLen = 75;

    const breakWord = (str: string): string => {
        const regex = /(,(?=\S)|:)/g; // ERY: Finds a comma without a space after it. So far, seems to be the most common occurrence for a long string.
        const subst = `, `;
        const result = str.replace(regex, subst);
        return shortenStr(result, maxStrLen);
    };

    const Chart = (
        <>
            <CircleOuterWrap
                mobileInitDiam={mobileDiams.initial}
                mobileExpDiam={mobileDiams.expanded}
                desktopInitDiam={desktopDiams.initial}
                desktopExpDiam={desktopDiams.expanded}
            >
                <CircleInnerWrap className={isActive ? "active" : null}>
                    {centralIcon}
                    <CentralPercent>{Math.round(centralPercent * 100)}%</CentralPercent>
                    <CircleLeft
                        className={isActive ? "active" : null}
                        backgroundColor={colorTwoBright}
                        percent={percent1}
                        mobileInitDiam={mobileDiams.initial}
                        mobileExpDiam={mobileDiams.expanded}
                        desktopInitDiam={desktopDiams.initial}
                        desktopExpDiam={desktopDiams.expanded}
                    >
                        <PercentLineTotal />
                        <PercentLine />
                        <LineIndicator />
                        <div>
                            <PercentCounterCircle />
                            <PercentText>{Math.round(percent1 * 100)}%</PercentText>
                        </div>
                        <LocationName>
                            {breakWord(location1Name)}
                            <div>Customers</div>
                        </LocationName>
                    </CircleLeft>
                    <CircleRight
                        className={isActive ? "active" : null}
                        backgroundColor={colorTwoDark}
                        percent={percent2}
                        mobileInitDiam={mobileDiams.initial}
                        mobileExpDiam={mobileDiams.expanded}
                        desktopInitDiam={desktopDiams.initial}
                        desktopExpDiam={desktopDiams.expanded}
                    >
                        <PercentLineTotal />
                        <PercentLine />
                        <LineIndicator />
                        <div>
                            <PercentCounterCircle />
                            <PercentText>{Math.round(percent2 * 100)}%</PercentText>
                        </div>
                        <LocationName>
                            {breakWord(location2Name)}
                            <div>Customers</div>
                        </LocationName>
                    </CircleRight>
                </CircleInnerWrap>
            </CircleOuterWrap>
            <ChartDotsWrap>
                <ChartDots>
                    <ChartDot color={colorTwoBright}>
                        {shortenStr(location1Name, maxStrLen)}
                    </ChartDot>
                    <ChartDot color={colorTwoDark}>
                        {shortenStr(location2Name, maxStrLen)}
                    </ChartDot>
                </ChartDots>
            </ChartDotsWrap>
        </>
    );

    return Chart;
};
